// Age limit slider handler
export const updateAgeLimitSlider = () => {
  const minSlider = document.getElementById('ageLimitMin');
  const maxSlider = document.getElementById('ageLimitMax');
  if (!minSlider || !maxSlider) return;
  
  let minVal = parseInt(minSlider.value);
  let maxVal = parseInt(maxSlider.value);
  
  // Ensure min doesn't exceed max
  if (minVal > maxVal) {
    minSlider.value = maxVal;
    minVal = maxVal;
  }
  if (maxVal < minVal) {
    maxSlider.value = minVal;
    maxVal = minVal;
  }
  
  window.currentAgeMin = minVal;
  window.currentAgeMax = maxVal;
  
  // Update track highlight
  const track = document.getElementById('ageLimitTrack') || document.getElementById('editAgeLimitTrack');
  if (track) {
    const range = 99 - 18;
    const leftPercent = ((minVal - 18) / range) * 100;
    const rightPercent = ((99 - maxVal) / range) * 100;
    track.style.left = leftPercent + '%';
    track.style.right = rightPercent + '%';
  }
  
  // Update label
  const label = document.getElementById('ageLimitLabel') || document.getElementById('editAgeLimitLabel');
  if (label) {
    if (minVal === 18 && maxVal === 99) {
      label.textContent = '18 - 99 (all ages)';
    } else {
      label.textContent = minVal + ' - ' + maxVal;
    }
  }
  
  // Trigger save button in edit mode
  if (window.updateSaveButtonState) {
    window.updateSaveButtonState();
  }
};

// Edit mode age limit slider handler
export const updateEditAgeLimitSlider = () => {
  const minSlider = document.getElementById('editAgeLimitMin');
  const maxSlider = document.getElementById('editAgeLimitMax');
  if (!minSlider || !maxSlider) return;
  
  let minVal = parseInt(minSlider.value);
  let maxVal = parseInt(maxSlider.value);
  
  if (minVal > maxVal) {
    minSlider.value = maxVal;
    minVal = maxVal;
  }
  if (maxVal < minVal) {
    maxSlider.value = minVal;
    maxVal = minVal;
  }
  
  window.currentAgeMin = minVal;
  window.currentAgeMax = maxVal;
  
  const track = document.getElementById('editAgeLimitTrack');
  if (track) {
    const range = 99 - 18;
    const leftPercent = ((minVal - 18) / range) * 100;
    const rightPercent = ((99 - maxVal) / range) * 100;
    track.style.left = leftPercent + '%';
    track.style.right = rightPercent + '%';
  }
  
  const label = document.getElementById('editAgeLimitLabel');
  if (label) {
    if (minVal === 18 && maxVal === 99) {
      label.textContent = '18 - 99 (all ages)';
    } else {
      label.textContent = minVal + ' - ' + maxVal;
    }
  }
  
  if (window.updateSaveButtonState) {
    window.updateSaveButtonState();
  }
};

if (!window._ageLimitCSSAdded) {
  window._ageLimitCSSAdded = true;
  const ageLimitStyle = document.createElement('style');
  ageLimitStyle.textContent = `
    #ageLimitMin::-webkit-slider-thumb,
    #ageLimitMax::-webkit-slider-thumb,
    #editAgeLimitMin::-webkit-slider-thumb,
    #editAgeLimitMax::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 24px;
      height: 24px;
      background: white;
      border: 3px solid #2c2c2c;
      border-radius: 50%;
      cursor: pointer;
      pointer-events: auto;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      position: relative;
      z-index: 5;
    }
    #ageLimitMin::-moz-range-thumb,
    #ageLimitMax::-moz-range-thumb,
    #editAgeLimitMin::-moz-range-thumb,
    #editAgeLimitMax::-moz-range-thumb {
      width: 24px;
      height: 24px;
      background: white;
      border: 3px solid #2c2c2c;
      border-radius: 50%;
      cursor: pointer;
      pointer-events: auto;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    }
  `;
  document.head.appendChild(ageLimitStyle);
}

// Initialize age limit defaults
if (window.currentAgeMin === undefined) {
  window.currentAgeMin = 18;
}
if (window.currentAgeMax === undefined) {
  window.currentAgeMax = 99;
}

// Category selection for event creation
if (!window.currentEventCategories) {
  window.currentEventCategories = []; // Array of selected categories (max 3)
}

export const selectEventCategory = (category) => {
  const idx = window.currentEventCategories.indexOf(category);
  if (idx > -1) {
    // Deselect - create new array without this item
    window.currentEventCategories = window.currentEventCategories.filter(c => c !== category);
  } else {
    // Select - if already 3, remove the first one and add new
    if (window.currentEventCategories.length >= 3) {
      window.currentEventCategories = [...window.currentEventCategories.slice(1), category];
    } else {
      window.currentEventCategories = [...window.currentEventCategories, category];
    }
  }
  
  // Remove category error if any category is now selected
  if (window.currentEventCategories.length > 0) {
    document.querySelectorAll('#categoryPickerButtons, #editCategoryPickerButtons').forEach(function(container) {
      var error = container.parentElement ? container.parentElement.querySelector('.error-message') : null;
      if (error) error.remove();
    });
  }
  // Update ALL category button containers that exist
  window.updateCategoryButtonStyles('categoryPickerButtons');
  window.updateCategoryButtonStyles('editCategoryPickerButtons');
};

// Shared function to update category button styles (used by both create and edit)
export const updateCategoryButtonStyles = (containerId) => {
  if (!containerId) return;
  const container = document.getElementById(containerId);
  if (!container) return;
  container.querySelectorAll('button[data-category]').forEach(btn => {
    const isSelected = window.currentEventCategories.includes(btn.dataset.category);
    btn.style.borderColor = isSelected ? '#2c2c2c' : '#d1d5db';
    btn.style.background = isSelected ? '#f0f0f0' : 'white';
    btn.style.fontWeight = isSelected ? '600' : '400';
  });
  
  // Update counter text - check both possible counter IDs
  const counterId = containerId === 'editCategoryPickerButtons' ? 'editCategoryPickerCount' : 'categoryPickerCount';
  const counter = document.getElementById(counterId);
  if (counter) {
    const count = window.currentEventCategories.length;
    counter.textContent = count > 0 ? count + '/3 selected' : 'Select up to 3 categories';
  }
  
  // Trigger save button check in edit mode
  if (containerId === 'editCategoryPickerButtons' && window.updateSaveButtonState) {
    window.updateSaveButtonState();
  }
};

window.updateAgeLimitSlider = updateAgeLimitSlider;
window.updateEditAgeLimitSlider = updateEditAgeLimitSlider;
window.selectEventCategory = selectEventCategory;
window.updateCategoryButtonStyles = updateCategoryButtonStyles;